// import React, { useEffect, useState } from 'react';
// import { useLocation, useParams, Link } from 'react-router-dom';
// import he from 'he';

//  const catLinks = {
//     25: "/contents/latestnews-25.html",
//     36: "/contents/latestnews-25.html",
//     45: "/contents/analytical-45.html",
//     39: "/contents/politics-39.html",
//     35: "/contents/lifestyle-35.html",
//     34: "/contents/health-34.html",
//     60: "/contents/specialAnalysis-60.html", 
//     43: "/contents/andhrapradesh-43.html",
//     24: "/contents/telangana-24.html",
//     23: "/contents/india-23.html",
//     58: "/contents/world-58.html",
//     54: "/contents/business-54.html",
//     33: "/contents/technology-33.html",
//     53: "/contents/sports-53.html",
//     55: "/contents/teluguoneexclusive-55.html",
//     57: "/contents/history-57.html",
//   };
// const MORE_NEWS_COUNT = 12;

// const RelatedSigmentNews = ({ relatedSigmentNews, relatedSigmentNewsError }) => {
//   const [content, setContent] = useState({
//     data: relatedSigmentNews || [],
//     error: relatedSigmentNewsError || null,
//     loading: !relatedSigmentNews && !relatedSigmentNewsError,
//   });

//   const location = useLocation().pathname;
//   let cuttedurl = location.substring(0, location.lastIndexOf('-'));
//   let catid = cuttedurl.substring(cuttedurl.lastIndexOf('-') + 1);
//   let contentid = location.substring(location.lastIndexOf('-') + 1, location.lastIndexOf('.html'));

//   const { contentText } = useParams();

//   useEffect(() => {
//     if (relatedSigmentNews && !relatedSigmentNewsError) {
//       return;
//     }

//     if (!relatedSigmentNews && relatedSigmentNewsError) {
//       setContent({ data: [], error: relatedSigmentNewsError, loading: false });
//       return;
//     }

//     const getMoreNews = async () => {
//       try {
//         const resp = await fetch(`https://www.teluguone.com/news_api/catNewsPaginate?catId=${catid}&start=0&total=${MORE_NEWS_COUNT + 2}`);
//         if (!resp.ok) throw new Error(`Server response was not OK`);
//         const rsData = await resp.json();
//         setContent({ data: rsData.morenews, error: null, loading: false });
//       } catch (error) {
//         console.log(`Error: ${error.message}`);
//         setContent({ data: [], error: error.message, loading: false });
//       }
//     };

//     getMoreNews();
//   }, [contentText]);

//   const items = (content.data || [])
//     .filter(item => {
//       const itemContentId = item?.url_link?.substring(item.url_link.lastIndexOf('-') + 1, item.url_link.lastIndexOf('.html'));
//       return itemContentId !== contentid;
//     })
//     .slice(0, MORE_NEWS_COUNT);


//   const getLink = (id) => {
//   return catLinks[String(id)] || catLinks["25"];
// };



//   // Loading UI
//   if (content.loading) {
//     return (
//       <div className='more-news-section'>
       
//         <div className='more-news-grid'>
//           {Array.from({ length: MORE_NEWS_COUNT }).map((_, i) => (
//             <div className='more-news-card more-news-card-skeleton' key={i}></div>
//           ))}
//         </div>
//       </div>
//     );
//   }

//   if (content.error) {
//     return (
//       <div className='more-news-section'>
      
//         <div className="json-loading-error-div mt-2">
//           <img src={`${import.meta.env.BASE_URL}assets/images/json_error.png`} alt="json_error" />
//         </div>
//       </div>
//     );
//   }

//   if (items.length === 0) {
//     return null;
//   }

//   // Main UI
//   return (
//     <div className='more-news-section'>

//       <div className='more-news-grid'>
//         {items.map((item, index) => (
//           <Link
//             key={item.url_link || index}
//             to={item.url_link ? item.url_link.substring(item.url_link.indexOf('/news') + 5) : '/'}
//             className='more-news-card'
//           >
//             <div className='more-news-card-img-wrap'>
//               <img loading='lazy' src={item.stimg} alt="more-news-img" />
//             </div>
//             <p dangerouslySetInnerHTML={{ __html: item.title ? he.decode(item.title) : '' }}></p>
//           </Link>
//         ))}
//       </div>
//      <Link to={getLink(catid)} style={{textDecoration:"none"}}>
//   <button
//     className="latest-side-news-view-more-btn notranslate down"
//     type="button"
//     translate="no"
//   >
//     More News
//   </button>
// </Link>
//     </div>
//   );
// };

// export default RelatedSigmentNews;


import React, { useEffect, useState } from 'react';
import { useLocation, useParams, Link } from 'react-router-dom';
import he from 'he';

const MORE_NEWS_COUNT = 12;
const BOTTOM_FETCH_COUNT = 20;

const catLinks = {
  25: "/contents/latestnews-25.html",
  36: "/contents/latestnews-25.html",
  45: "/contents/analytical-45.html",
  39: "/contents/politics-39.html",
  35: "/contents/lifestyle-35.html",
  34: "/contents/health-34.html",
  60: "/contents/specialAnalysis-60.html",
  43: "/contents/andhrapradesh-43.html",
  24: "/contents/telangana-24.html",
  23: "/contents/india-23.html",
  58: "/contents/world-58.html",
  54: "/contents/business-54.html",
  33: "/contents/technology-33.html",
  53: "/contents/sports-53.html",
  55: "/contents/teluguoneexclusive-55.html",
  57: "/contents/history-57.html",
};

const RelatedSigmentNews = () => {

  const { contentText } = useParams();
  const location = useLocation();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

    if (!contentText) return;

    const pathname = location.pathname;

    const cuttedUrl = pathname.substring(
      0,
      pathname.lastIndexOf('-')
    );

    const catId = cuttedUrl.substring(
      cuttedUrl.lastIndexOf('-') + 1
    );

    const contentId = pathname.substring(
      pathname.lastIndexOf('-') + 1,
      pathname.lastIndexOf('.html')
    );

    const getMoreNews = async () => {

      setLoading(true);
      setError(null);

      try {

        // Fetch BOTH APIs
        const [sideResponse, bottomResponse] = await Promise.all([
          fetch(
            `https://www.teluguone.com/news_api/newsDetailedMoreNewsJson?catid=${catId}&contentid=${contentId}`
          ),

          fetch(
            `https://www.teluguone.com/news_api/catNewsPaginate?catId=${catId}&start=0&total=${BOTTOM_FETCH_COUNT}`
          )
        ]);

        if (!sideResponse.ok) {
          throw new Error(
            `Side news API failed: ${sideResponse.status}`
          );
        }

        if (!bottomResponse.ok) {
          throw new Error(
            `Bottom news API failed: ${bottomResponse.status}`
          );
        }

        const [sideResult, bottomResult] = await Promise.all([
          sideResponse.json(),
          bottomResponse.json()
        ]);

        // -----------------------------------------
        // 1. Get side news IDs
        // -----------------------------------------

        const sideNews = Array.isArray(sideResult?.morenews)
          ? sideResult.morenews
          : [];

        const sideNewsIds = new Set(
          sideNews
            .map(item => {

              const url = item?.url_link || '';

              return url.substring(
                url.lastIndexOf('-') + 1,
                url.lastIndexOf('.html')
              );

            })
            .filter(Boolean)
        );


        // -----------------------------------------
        // 2. Get bottom news
        // -----------------------------------------

        const bottomNews = Array.isArray(bottomResult?.morenews)
          ? bottomResult.morenews
          : [];


        // -----------------------------------------
        // 3. Remove:
        //    - current article
        //    - side 5 articles
        // -----------------------------------------

        const filteredNews = bottomNews
          .filter(item => {

            const url = item?.url_link || '';

            if (!url) {
              return false;
            }

            const itemContentId = url.substring(
              url.lastIndexOf('-') + 1,
              url.lastIndexOf('.html')
            );

            // Remove current article
            if (itemContentId === contentId) {
              return false;
            }

            // Remove articles already shown in side
            if (sideNewsIds.has(itemContentId)) {
              return false;
            }

            return true;
          })
          .slice(0, MORE_NEWS_COUNT);


        setData(filteredNews);

      } catch (err) {

        console.error("RelatedSigmentNews:", err);

        setError(err.message);

        setData([]);

      } finally {

        setLoading(false);

      }

    };

    getMoreNews();

  }, [contentText, location.pathname]);


  const getLink = () => {

    const cuttedUrl = location.pathname.substring(
      0,
      location.pathname.lastIndexOf('-')
    );

    const catId = cuttedUrl.substring(
      cuttedUrl.lastIndexOf('-') + 1
    );

    return catLinks[Number(catId)] || "/";

  };


  // -----------------------------------------
  // Loading
  // -----------------------------------------

  if (loading) {

    return (
      <div className="more-news-section">

        <div className="more-news-grid">

          {Array.from({
            length: MORE_NEWS_COUNT
          }).map((_, index) => (

            <div
              className="more-news-card more-news-card-skeleton"
              key={index}
            />

          ))}

        </div>

      </div>
    );

  }


  // -----------------------------------------
  // Error
  // -----------------------------------------

  if (error) {

    return (
      <div className="more-news-section">

        <div className="json-loading-error-div mt-2">

          <img
            src={`${import.meta.env.BASE_URL}assets/images/json_error.png`}
            alt="json_error"
          />

        </div>

      </div>
    );

  }


  // -----------------------------------------
  // No news
  // -----------------------------------------

  if (data.length === 0) {
    return null;
  }


  // -----------------------------------------
  // UI
  // -----------------------------------------

  return (

    <div className="more-news-section">

      <div className="more-news-grid">

        {data.map((item, index) => (

          <Link
            key={item.url_link || index}
            to={
              item.url_link
                ? item.url_link.substring(
                    item.url_link.indexOf('/news') + 5
                  )
                : '/'
            }
            className="more-news-card"
          >

            <div className="more-news-card-img-wrap">

              <img
                loading="lazy"
                src={item.stimg}
                alt={item.title || "more-news-img"}
              />

            </div>

            <p
              dangerouslySetInnerHTML={{
                __html: item.title
                  ? he.decode(item.title)
                  : ''
              }}
            />

          </Link>

        ))}

      </div>


      <Link
        to={getLink()}
        style={{ textDecoration: "none" }}
      >

        <button
          className="latest-side-news-view-more-btn notranslate down"
          type="button"
          translate="no"
        >
          More News
        </button>

      </Link>

    </div>

  );

};

export default RelatedSigmentNews;